import React from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import TableComplex from "../../vapor/tableComplex";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import moment from "moment";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";

const VatEntriesTable = () => {

  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const entriesData = useSelector(state => state.reports.vat?.aliquoteDetail);

  const [currentRecord, setCurrentRecord] = useState(null);

  let columnsEntries = [
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.registrationDate" }),
      width: "7%",
      dataIndex: "registrationDate",
      key: "registrationDate",
      render: value => moment(value).format("DD/MM/YYYY")
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.docType" }),
      width: "11%",
      dataIndex: "reasonDescription",
      key: "reasonDescription"
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.vatType" }),
      width: "15%",
      dataIndex: "vatType",
      key: "vatType"
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.docNumber" }),
      width: "8%",
      dataIndex: "docNumber",
      key: "docNumber"
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.docDate" }),
      width: "7%",
      dataIndex: "docDate",
      key: "docDate",
      render: value => moment(value).format("DD/MM/YYYY")
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.customerOrSupplier" }),
      width: "13%",
      dataIndex: "customerOrSupplier",
      key: "customerOrSupplier"
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.vatNumberOrTaxId" }),
      width: "10%",
      dataIndex: "vatNumberOrTaxId",
      key: "vatNumberOrTaxId"
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.aliquote" }),
      width: "6%",
      dataIndex: "vatRate",
      key: "vatRate"
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.taxable" }),
      width: "7%",
      dataIndex: "taxable",
      key: "taxable"
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.tax" }),
      width: "7%",
      dataIndex: "tax",
      key: "tax"
    },
    {
      title: intl.formatMessage({ id: "reports.vatEntries.table.total" }),
      width: "7%",
      dataIndex: "totalAmount",
      key: "totalAmount"
    },
    {
      title: "",
      width: "2%",
      dataIndex: "detail",
      key: "detail"
    }
  ];

  const buildDataSource = () => {
    return entriesData?.map((entry, key) => renderTableRow(entry));
  };

  const goToDetails = (originalEntry) => {   
    dispatch(getDraftIdFromOriginalEntry(originalEntry)).then((res) => {
      navigate(`/precog-detail/${res}`, {state: {goBack: true}});      
    }).catch(err => {

    });
  };

  const renderTableRow = entry => {
    let taxableSum = 0;
    let taxSum = 0;
    let amountSum = 0;
    entry?.vatLines.map(el => {
      taxableSum = taxableSum + el.taxable;
      taxSum = taxSum + el.tax;
      amountSum = amountSum + el.totalAmount;
    });
  
    return {
      key: entry.registrationUuid,
      entry: entry,      
      registrationDate: entry.registrationDate,
      reasonDescription: entry.reasonDescription,
      vatType: entry.vatType ? entry.vatType : "-",
      docNumber: entry.docNumber,
      docDate: <div>{moment(entry.docDate).format(DATE_FORMAT_FOR_DISPLAY)}</div>,
      customerOrSupplier: entry.supplier ? entry.supplier.supplierName : entry.customer.customerName,
      vatNumberOrTaxId: entry.supplier ?
        entry.supplier.supplierVatNumber ? entry.supplier.supplierVatNumber : entry.supplier.supplierTaxId :
        entry.customer.customerVatNumber ?  entry.customer.customerVatNumber : entry.customer.customerTaxId,
      vatRate: entry.vatLines.length > 1 ?
        <div style={{ display: "flex" }}>
          <div>...</div>
          <FontAwesomeIcon style={{ width: "100%" }} className="icon" icon={["far", "angle-down"]} onClick={() => setCurrentRecord([entry.registrationUuid])} />
        </div> :
        <FormattedMessage id={`reports.vatEntries.table.taxEnums.${entry.vatLines[0].vatRate}`} />,
      taxable: `${numeral(Math.abs(taxableSum)).format("0,0.00")}€`,
      tax: `${numeral(Math.abs(taxSum)).format("0,0.00")}€`,
      totalAmount: `${numeral(Math.abs(amountSum)).format("0,0.00")}€`,
      detail: <div><FontAwesomeIcon className="icon" icon={["far", "angle-right"]} onClick={() => goToDetails(entry.registrationUuid)} /></div>
    };
  };
  return (
    <div>
      <TableComplex
        dataSource={buildDataSource()}
        columns={columnsEntries}
        expandable={{
          expandedRowKeys: currentRecord,
          rowExpandable: record => record.entry.vatLines.length > 1,
          expandRowByClick: true,
          showExpandColumn: false,
          expandedRowRender: (record, index) => {
            return <div className="vat-container">
              {record.entry.vatLines.map((el, index) =>
                <div key={index} className="vat-row">
                  <div style={{width: "71%"}}>
                  </div>
                  <div style={{paddingLeft: "4px", width: "6%"}}>
                    <FormattedMessage id={`reports.vatEntries.table.taxEnums.${el.vatRate}`} />
                  </div>
                  <div style={{paddingLeft: "4px", width: "7%"}}>
                    {`${numeral(Math.abs(el.taxable)).format("0,0.00")}€`}
                  </div>
                  <div style={{paddingLeft: "4px", width: "6%"}}>
                    {`${numeral(Math.abs(el.tax)).format("0,0.00")}€`}
                  </div>
                </div>)
              }
            </div>;
          }
        }}
      />
    </div>
  );
};
export default VatEntriesTable;
